angular
  .module('contabilidad.polizas')
  .service('provisionNominaServiceLNF', Service)

Service.$inject = ['$api', '$filter', '$schema']

function Service ($api, $filter, $schema) {
  var provisionNominaServiceLNF = this

  provisionNominaServiceLNF.obtenerInformacionProvisionNomina = obtenerInformacionProvisionNomina
  provisionNominaServiceLNF.codificarProvisionNomina = codificarProvisionNomina

  function obtenerInformacionProvisionNomina (fecha_inicio, ids_nominas) {
    return $api.get('/kendu/contabilidad/polizas/polizaProvisionNomina', {
      fecha_inicio: fecha_inicio.toYMD(),
      ids_Nominas: ids_nominas,
    }).then(function (data) {
      return data.map(function (item) {
        item.ID_EmpleadoZ = ('000000' + item.ID_Empleado).slice(-6)
        item.ID_EmpresaZ = ('0000' + item.ID_Empresa).slice(-4)
        return $schema(item, {
          Abono: 'number',
          Cargo: 'number',
          Provision: 'number',
          Deudor: 'number',
        })
      })
    })
  }

  var verificarCadena = $filter('rPad')

  function codificarProvisionNomina (data, inicio_poliza, fecha_inicio) {
    var cadenaPrincipal = '',
      cadA = 'P  AAAAMMDD    3      JJJJ 1 0          ' +
        'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX                                         11 1 0\\n',
      cadB = 'M1 CCCCCCCCCCCCCCCC               ZZZZZZZZZZZZZZZ      * YYYYYYYYY            0          0.0' +
        '                  NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN \\n',

      fechaA = $filter('date')(fecha_inicio, 'yyyyMMdd'),
      fechaB = $filter('date')(fecha_inicio, 'dd/MM/yyyy'),

      vuelta = 0,
      TotalAbonos = 0
    try {
      data.forEach(function (item) {
        if (vuelta === 0) {
          fechaA = $filter('date')(item.fec_nomina, 'yyyyMMdd'),
            cadenaPrincipal += cadA
              .replace('AAAAMMDD', fechaA)
              .replace('JJJJ', ('000' + inicio_poliza).slice(-4))
              .replace('XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX', verificarCadena(item.Descripcion + ' ' + item.ID_Nomina, 60))
        }

        fechaB = verificarCadena(item.ID_Nomina, 15)

        // HONORARIOS ASIMILADOS A SALARIOS
        cadenaPrincipal += cadB
          .replace('CCCCCCCCCCCCCCCC', verificarCadena(('6030310000000000'), 16))
          .replace('ZZZZZZZZZZZZZZZ', fechaB)
          .replace('*', 0)
          .replace('YYYYYYYYY', verificarCadena((item.Cargo.toFixed(2)), 9))
          .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', verificarCadena(('HONORARIOS ASIMILADOS A SALARIOS ' + item.Nombre), 43))

        // IMPUESTO SOBRE LA RENTA ISR
        TotalAbonos += item.Abono

        if (item.Deudor !== 0) {
          cadenaPrincipal += cadB
            .replace('CCCCCCCCCCCCCCCC', verificarCadena('107006' + item.ID_EmpresaZ + item.ID_EmpleadoZ, 16))
            .replace('ZZZZZZZZZZZZZZZ', fechaB)
            .replace('*', 1)
            .replace('YYYYYYYYY', verificarCadena(item.Deudor.toFixed(2), 9))
            .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', verificarCadena(('DEUDORES DIVERSOS ' + item.Nombre), 43))
        }

        // PROVISION
        cadenaPrincipal += cadB
          .replace('CCCCCCCCCCCCCCCC', verificarCadena('2100050000000000', 16))
          .replace('ZZZZZZZZZZZZZZZ', fechaB)
          .replace('*', 1)
          .replace('YYYYYYYYY', verificarCadena(item.Provision.toFixed(2), 9))
          .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', verificarCadena((item.Nombre), 43))
        vuelta++
        // inicio_poliza++;
      })

      cadenaPrincipal += cadB
        .replace('CCCCCCCCCCCCCCCC', verificarCadena('2160020000000000', 16))
        .replace('ZZZZZZZZZZZZZZZ', fechaB)
        .replace('*', 1)
        .replace('YYYYYYYYY', verificarCadena(TotalAbonos.toFixed(2), 9))
        .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', verificarCadena(('IMPUESTO SOBRE LA RENTA '), 43))

      return cadenaPrincipal
    } catch (err) { // try
      return 'Error'
    }
  }

}




// WEBPACK FOOTER //
// ./src/contabilidad/polizas/services/provisionNominaLNFService.js